export const login = (user) => {
    return { type: "LOGIN", payload: user };
};
export const logout = () => {
    return { type: "LOGOUT" };
};

export const changeUnit = (unitType) => {
    return { type: "CHANGEUNIT", payload: unitType }
}